/**
 * FicheSummary — résumé FACTUEL et UTILE du séjour (aucune invention).
 * Construit à partir de la note Lodgify et des messages voyageur synchronisés :
 * fait ressortir uniquement les éléments importants (raison du séjour, demandes,
 * paiements, préférences, allergies, surprises, points à ne pas oublier).
 * N'affiche PAS les formulaires à envoyer, ni un compteur brut de messages,
 * ni une simple copie du dernier message.
 */

const CATEGORIES = [
  { key: "allergie", icon: "⚠️", label: "Allergie / intolérance", re: /\b(allerg|intol[ée]ran|sans gluten|lactose|arachide|fruits? [àa] coque)\w*/i },
  { key: "occasion", icon: "🎉", label: "Occasion spéciale", re: /\b(anniversaire|lune de miel|romantiqu|surpris|demande en mariage|noces|c[ée]l[ée]bration|f[êe]ter)\w*/i },
  { key: "paiement", icon: "💶", label: "Paiement", re: /\b(paiement|pay[ée]|acompte|solde|caution|rembours|arrhes|re[çc]u)\w*/i },
  { key: "horaire", icon: "🕐", label: "Arrivée / départ", re: /\b(arriv[ée]e tardive|arriver[ao]ns?|d[ée]part|check[- ]?in|check[- ]?out|tard|t[ôo]t|vers \d{1,2}h)\w*/i },
  { key: "animal", icon: "🐾", label: "Animal", re: /\b(animal|animaux|chien|chat|chiens?|chats?)\b/i },
  { key: "regime", icon: "🥗", label: "Régime", re: /\b(v[ée]g[ée]tarien|v[ée]gan|v[ée]g[ée]talien|halal|casher)\w*/i },
  { key: "demande", icon: "📌", label: "Demande particulière", re: /\b(pourriez|serait[- ]il possible|j'aimerais|nous aimerions|besoin|demande|souhait|pouvez[- ]vous|est[- ]il possible)\w*/i },
];

function cleanText(t) {
  return String(t || "").replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim();
}

function splitSentences(t) {
  return cleanText(t)
    .split(/(?<=[.!?])\s+|\n+/)
    .map((s) => s.trim())
    .filter((s) => s.length > 3);
}

export default function FicheSummary({ reservation: r }) {
  const sources = [];
  if ((r.notes_lodgify || "").trim()) sources.push(...splitSentences(r.notes_lodgify));
  (Array.isArray(r.messages) ? r.messages : [])
    .filter((m) => m.sender === "guest")
    .forEach((m) => sources.push(...splitSentences(m.text)));

  // Un point par catégorie détectée, avec la 1ʳᵉ phrase pertinente (sans doublon)
  const seen = new Set();
  const found = [];
  for (const cat of CATEGORIES) {
    const hit = sources.find((s) => cat.re.test(s));
    if (hit && !seen.has(hit.toLowerCase())) {
      seen.add(hit.toLowerCase());
      const trimmed = hit.length > 160 ? hit.slice(0, 160) + "…" : hit;
      found.push({ icon: cat.icon, label: cat.label, text: trimmed });
    }
  }

  if (found.length === 0) {
    return (
      <p className="rg-muted" data-testid="rg-fiche-summary-empty" style={{ margin: 0, fontSize: 13 }}>
        Aucune particularité importante détectée pour l&apos;instant dans la note Lodgify ou les échanges.
      </p>
    );
  }

  return (
    <div data-testid="rg-fiche-summary" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {found.map((l, i) => (
        <div key={i} style={{ fontSize: 13, lineHeight: 1.45, display: "flex", gap: 8 }}>
          <span style={{ flexShrink: 0 }} title={l.label}>{l.icon}</span>
          <span style={{ color: "var(--rg-text)" }}><b>{l.label} :</b> {l.text}</span>
        </div>
      ))}
    </div>
  );
}
